<template>
    <div>
        Articles
    </div>
</template>

<script>
export default {
    name: "Articles",
    components: {},
    props: {},
    data() {
        return {}
    },
    mounted() {
    },
    methods: {},
    computed: {},
    filters: {},
    watch: {}
}
</script>

<style scoped>

</style>
